define.alias("shared/components/shared/ui/education", "calendar/components/shared/ui/education");